import { getAuth, signOut } from 'firebase/auth';
import { logout } from '@/api/auth';

import {
  AuthModule,
  AuthState,
  AuthMutationTree,
  AuthActionTree,
  AuthGetterTree,
} from '@/store/@types/auth';

const state: AuthState = {
  isAuthModalVisible: false,
  token: '',
  user: null,
};

const mutations: AuthMutationTree = {
  SET_AUTH_MODAL_VISIBILITY(state, isVisible) {
    state.isAuthModalVisible = isVisible;
  },

  SET_TOKEN(state, token) {
    localStorage.setItem('token', token);

    state.token = token;
  },

  SET_USER(state, user) {
    localStorage.setItem('user', JSON.stringify(user));

    state.user = user;
  },
};

const actions: AuthActionTree = {
  setAuthModalVisibility({ commit }, isVisible) {
    commit('SET_AUTH_MODAL_VISIBILITY', isVisible);
  },

  async logout({ commit }) {
    const auth = getAuth();

    await signOut(auth);
    await logout();

    commit('SET_TOKEN', '');
    commit('SET_USER', null);
  },
};

const getters: AuthGetterTree = {
  user: (state) => state.user,

  userEmpty: (state) => {
    if (!state.user) {
      return true;
    }

    return Object.keys(state.user).length === 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as AuthModule;
